import { useCallback } from 'react';
import { fetchLaunchpadThunk } from 'src/features/common/launchpad/ducks/launchpad/launchpad.thunk';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { selectLaunchpadsEntities } from '../ducks/launchpad/launchpad.selectors';
import { actions } from '../ducks/launchpad/launchpad.slice';

export const useFetchLaunchpad = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        async (id: string) => {
            const res = await dispatch(fetchLaunchpadThunk(id));
            return res;
        },
        [dispatch]
    );
};

export const useClearLaunchpad = () => {
    const dispatch = useAppDispatch();

    return useCallback(() => {
        dispatch(actions.clear());
    }, [dispatch]);
};

export const useLaunchpadById = (id?: string) => {
    const byId = useAppSelector(selectLaunchpadsEntities);
    if (!id) {
        return undefined;
    }
    return byId[id];
};